// Libraries
import {
  generatePath,
  Link,
  matchPath,
  useMatches,
  useParams,
} from "react-router-dom";

// General
import { helperPathname, pathname } from "#src/config/pathname";

// Children
import { noSidebarPaths } from "../pathConfig";
import LayoutSidebarAccountMenu from "./AccountMenu";
import SidebarHeader from "./Header";
import LayoutSidebarMainMenu from "./MainMenu";
import { ReactComponent as AppsLine } from "#src/assets/images/icons/apps-line.svg";
import { ReactComponent as ArrowRightUpLine } from "#src/assets/images/icons/arrow-right-up-line.svg";
import { useTranslation } from "react-i18next";

export const LayoutSidebar = () => {
  const { t } = useTranslation("layout", { keyPrefix: "sidebar" });

  const pathMatches = useMatches();

  const { workspaceId } = useParams<"workspaceId">();

  const noSidebarMode = pathMatches.some((match) =>
    noSidebarPaths.some((path) => matchPath(path, match.pathname))
  );

  const isNotShowSolution = pathMatches.some(
    (match) =>
      matchPath(helperPathname.ACCOUNT, match.pathname) ||
      matchPath(helperPathname.WORKSPACE, match.pathname)
  );

  return noSidebarMode ? null : (
    <div
      id="whitehub-sidebar"
      // If this width changes, please do remember to check and fix related widths on ./index.tsx
      className={`relative flex flex-col z-[1] h-full shadow-lg flex-1 lg:max-w-[22rem] max-w-[16.75rem] transition-all`}
    >
      <SidebarHeader />
      <div
        className={`${
          isNotShowSolution ? "h-[calc(100%_-_4rem)]" : "h-[calc(100%_-_7rem)]"
        } flex `}
      >
        <LayoutSidebarMainMenu />
        <LayoutSidebarAccountMenu />
      </div>
      {workspaceId && !isNotShowSolution ? (
        <Link
          to={generatePath(pathname.SOLUTIONS, {
            workspaceId,
          })}
          className={`absolute left-0 right-0 z-50 bottom-0 flex justify-between bg-dark-blue items-center py-5 text-white hover:text-white no-underline hover:bg-grey-blue px-6 border-t border-solid border-grey-blue font-medium-16`}
        >
          <div className="flex items-center gap-3">
            <AppsLine />
            <span>{t("allSolutions")}</span>
          </div>
          <ArrowRightUpLine />
        </Link>
      ) : null}
    </div>
  );
};
